module.exports = __webpack_public_path__ + "static/media/07.94f30528.jpg";